import * as React from 'react';
import styled from 'styled-components';

import { SectionInfoNarrow } from '../layout/SectionInfoNarrow';
import { Container } from '../layout/Container';
import { LogoContainer } from '../ui/logo/LogoContainer';
import { SectionContact } from '../layout/SectionContact';
import { Overlap } from '../layout/Overlap';
import { Page } from '../layout/Page';
import { Seo } from '../../utils/seo/Index';
import { SectionServices } from '../layout/SectionServices';
import { CONTENT_ITEM } from '../../../client/__graphql__/queries/page_content/getPageContent';
import { useParams } from 'react-router';
import { useQuery } from '@apollo/client';
import { SectionNewsCard } from '../layout/SectionNewsCard';
import {
  Query,
  QueryGetPageContentInputArgs,
} from '../../../client/types/generated/types';
import { ImageCarousel } from '../layout/carousel/ImageCarousel_v2';
import { PageContentType } from '../../../server/global/enum';
import { getAdminClient } from '../layout/admin/AdminApolloClient';

type GetPageItem = Pick<Query, 'getNdPageContent'>;
type GetPageItemVariables = QueryGetPageContentInputArgs;

const PortalPageContent: React.FC = () => {
  const params = useParams<{ urltag: string }>();

  const { data, loading } = useQuery<GetPageItem, GetPageItemVariables>(
    CONTENT_ITEM,
    {
      fetchPolicy: 'network-only',
      variables: {
        input: {
          urltag: params.urltag,
          type: PageContentType.FORSALE,
        },
      },
    }
  );

  if (loading) {
    return null;
  }

  return (
    <>
      <Seo
        title={`Nybygg - PrivatMegleren - ${data?.getNdPageContent?.seo?.title}`}
        description={
          data?.getNdPageContent?.seo?.text
            ? data?.getNdPageContent?.seo?.text
            : undefined
        }
        image={
          data?.getNdPageContent?.seo?.image
            ? data?.getNdPageContent?.seo?.image
            : undefined
        }
      />
      <Page>
        <ImageCarousel
          title={data?.getNdPageContent?.title}
          url={data?.getNdPageContent?.image}
          imageList={data?.getNdPageContent?.imageList}
          get_properties={false}
        />
        <Container>
          <Overlap yPos={-70}>
            <SectionInfoNarrow
              title={data?.getNdPageContent?.title}
              hidedivider={false}
              ingress={data?.getNdPageContent?.ingress}
              info={data?.getNdPageContent?.text}
            ></SectionInfoNarrow>
          </Overlap>
          {data?.getNdPageContent?.config?.showSubpageNews ? (
            <SectionNewsCard />
          ) : null}
          {data?.getNdPageContent?.config?.showSubpageServices ? (
            <SectionServices />
          ) : null}
        </Container>
        {data?.getNdPageContent?.config?.showSubpageContact ? (
          <SectionContact />
        ) : null}
      </Page>
    </>
  );
};

export default PortalPageContent;
